import angular from 'angular';
import { projections } from '~/components/input-geo/input-geo.controller';
import kformUtils from '~/components/kform/utils/kform-utils';
import template from './geo.html';

const geoConfig = /* @ngInject */ (/** @type {any} */ KformComponentsProvider) => {
	KformComponentsProvider.register('geo', {
		title:      'Geo coords',
		template,
		group:      'advanced',
		children:   false,
		selectable: true,
		settings: {
			availableProjections:      projections.map(p => p.id),
			clearOnHide:               false,
			conditional: {
				eq: '',
				show: undefined,
				when: undefined,
			},
			disabled:                  false,
			event:                     {
				onChange: null,
			},
			hideLabel:                 false,
			hidden:                    false,
			input:                     true,
			kdata:                     {
				submit: true,
			},
			key:                       'geo',
			label:                     'Geographic coordinates',
			labelPosition:             'top',
			persistent:                true,
			projection:                'WGS84',
			showCurrentPositionButton: true,
			showMap:                   false,
			showMapButton:             true,
			showProjectionSelection:   true,
			tableView:                 true,
			validate:                  {
				card:   '0-1',
				custom: '',
			},
		},
		icon:          'fa fa-map',
		views:         [
			{
				name:     'Display',
				template: 'kform/components/geo/display.html',
			},
			{
				name:     'Validation',
				template: 'kform/components/geo/validate.html',
			},
			{
				name:     'API',
				template: 'kform/components/common/api.html',
			},
			{
				name:     'Layout',
				template: 'kform/components/common/layout.html',
			},
			{
				name:     'Conditional',
				template: 'kform/components/common/conditional.html',
			},
			{
				name:     'Events',
				template: 'kform/components/common/events.html',
			},
		],
		controller: /* @ngInject */ (
			/** @type {any} */ $scope,
		) => {
			if ($scope.options && $scope.options.building) {
				return;
			}

			$scope.changeValue = () => {
				if (typeof $scope.component.event.onChange === 'string') {
					const custom = ''.concat($scope.component.event.onChange, '; ');
					kformUtils.evaluate(custom, {
						data: $scope.data,
						form: $scope.form,
					});
				}
			};
		},
		onEdit: /* @ngInject */ (
			/** @type {any} */ $scope,
		) => {
			$scope.projections = projections;

			$scope.toggleSelectionAvailableProjection = (/** @type {any} */ projection) => {
				const index = $scope.component.availableProjections.indexOf(projection.id);

				// Is currently selected
				if (index > -1) {
					$scope.component.availableProjections.splice(index, 1);
				}
				// Is newly selected
				else {
					$scope.component.availableProjections.push(projection.id);
				}
			};
		},
	});
};

export default angular.module('app').config(geoConfig);
